import { AxiosRequestConfig } from 'axios';
import { restClient, restClientCaptcha } from '../rest-client';
import {
  IConfirmPhoneNumberData,
  IConfirmPhoneNumberResponse,
  ILoginData,
  IRegisterPhoneNumberData,
  ITokenData,
  IRegisterEmailData,
  IRefreshTokenFailedData,
} from './oauth.models';
import {
  TOKEN_URL,
  MOBILE_URL,
  MOBILE_CONFIRM_URL,
  REFRESH_URL,
  VERIFY_EMAIL_URL,
} from './oauth.request-urls';
import { CaptchaType } from '../../graphql/configuration';

export const oauthApi = {
  login(data: ILoginData) {
    return restClient.post<ITokenData>(TOKEN_URL, {
      ...data,
      grant_type: 'password',
    });
  },
  registerPhoneNumber(data: IRegisterPhoneNumberData) {
    return restClient.post<ITokenData>(MOBILE_URL, data);
  },
  registerPhoneNumberCaptcha(data: IRegisterPhoneNumberData, token: string, captchaType?: CaptchaType) {
    return restClientCaptcha(token, captchaType).post<ITokenData>(MOBILE_URL, data);
  },
  confirmPhoneNumber(data: IConfirmPhoneNumberData, config: AxiosRequestConfig) {
    return restClient.post<IConfirmPhoneNumberResponse>(
      MOBILE_CONFIRM_URL, data, config,
    );
  },
  refreshToken(data: ITokenData | null) {
    return restClient.post<ITokenData | IRefreshTokenFailedData>(REFRESH_URL, {
      ...data,
      grant_type: 'refresh_token',
    });
  },
  registerEmail(data: IRegisterEmailData, config: AxiosRequestConfig) {
    return restClient.post<ITokenData>(VERIFY_EMAIL_URL, data, config);
  },
};
